import React from "react";

const Restore = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="M6.571 17.778C6.571 10.169 12.712 4 20.286 4 27.859 4 34 10.17 34 17.778c0 7.608-6.14 13.778-13.714 13.778-3.14 0-6.027-1.072-8.343-2.863l2.156-2.197a10.57 10.57 0 0 0 6.187 1.998c5.89 0 10.666-4.8 10.666-10.716 0-5.917-4.777-10.716-10.666-10.716-5.89 0-10.667 4.799-10.667 10.716h4.572L8.095 23.9 2 17.778h4.571Z"
        />
        <path
            fill={fill}
            d="M20.286 14.716a3.054 3.054 0 0 1 3.047 3.062 3.054 3.054 0 0 1-3.047 3.062 3.054 3.054 0 0 1-3.048-3.062 3.054 3.054 0 0 1 3.048-3.062Z"
        />
    </svg>
);

export default Restore;